module.exports = __webpack_public_path__ + "img/webgl.c36b25d9.svg";